import {
    ADD_FEE_MARKUP_SUCCESS,
    ADD_FEE_MARKUP_FAILED,
    RESET_ADD_FEE_MARKUP,
    LOADING_ADD_FEE_MARKUP,
    NETWORK_ERROR_ADD_FEE_MARKUP,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADD_FEE_MARKUP:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };

        case ADD_FEE_MARKUP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };

        case ADD_FEE_MARKUP_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };

        case NETWORK_ERROR_ADD_FEE_MARKUP:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };

        case RESET_ADD_FEE_MARKUP:
            return (state = initialState);

        default:
            return state;
    }
};